import {ObjectSchema, ValidateOptions} from 'yup';
import {SEND_PARAMETER} from './constants';

export function castToSend<T extends object>(
   schema: ObjectSchema<T>,
   data: T,
   options?: ValidateOptions
) {
   return schema.cast(data, {
      ...options,
      context: {
         ...options?.context,
         [SEND_PARAMETER]: true,
      },
   });
}
